
import { RedoOutlined, SearchOutlined } from "@ant-design/icons";
import { AutoComplete, Button, Input, PageHeader, Skeleton, Table } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import StandByApi from "utils/composable/standByApi";
import humanize from "utils/formate-status";

const StandByProductReq = ({ currentUser }) => {
  const [tableLoading, setTableLoadings] = useState(false);
  //const [filteredData, setFilteredData] = useState(false)
  const [filteredData, setFilteredData] = useState(false);
  const [currentQuery, setCurrentQuery] = useState("");
  const { getHistoricalStandByRequest} = StandByApi();
  
  const [clientOptions, setClientOptions] = useState([]);
  const [productOptions, setProductOptions] = useState([]);
  const [clientSearchValue, setClientSearchValue] = useState('');
  const [productSearchValue, setProductSearchValue] = useState('');
  const [request, setRequest] = useState([]);

  useEffect(() => {
    if (!request.length) {
      setTableLoadings(true);
      getHistoricalStandByRequest().then((resp) => {
        setRequest(resp); // Set the state with the fetched data
        setTableLoadings(false);
      });
    }
  }, [request.length]);



  const [refreshLoading, setRefreshLoading] = useState(false);

  const fuzzyFilter = (query) => {
  console.log(query);
  setCurrentQuery(query);

  var get_bigrams, j, len, obj, relevance, results, string_similarity;

  get_bigrams = function (string) {
    var i, j, ref, s, v;
    s = string.toLowerCase();
    v = new Array(s.length - 1);
    for (i = j = 0, ref = v.length; j <= ref; i = j += 1) {
      v[i] = s.slice(i, i + 2);
    }
    return v;
  };

  string_similarity = function (str1, str2) {
    var hit_count, j, k, len, len1, pairs1, pairs2, union, x, y;
    if (str1.length > 0 && str2.length > 0) {
      pairs1 = get_bigrams(str1);
      pairs2 = get_bigrams(str2);
      union = pairs1.length + pairs2.length;
      hit_count = 0;
      for (j = 0, len = pairs1.length; j < len; j++) {
        x = pairs1[j];
        for (k = 0, len1 = pairs2.length; k < len1; k++) {
          y = pairs2[k];
          if (x === y) {
            hit_count++;
          }
        }
      }
      if (hit_count > 0) {
        return (2.0 * hit_count) / union;
      }
    }
    return 0.0;
  };

  if (query.length > 2) {
    results = [];

    for (j = 0, len = request.length; j < len; j++) {
      var req = request[j];
      relevance = string_similarity(query, req?.product?.name || "");

      obj = {
        ...req,
        relevance: relevance,
      };
      results.push(obj);
    }

    var sortedResults = results.filter((result) => result.relevance > 0.2);

    sortedResults = sortedResults
      .sort((a, b) => a.relevance - b.relevance)
      .reverse();

    setFilteredData(sortedResults);
  }
};
  const refresh = () => {
    setRefreshLoading(true);

    
    getHistoricalStandByRequest().finally(() => {
      setRefreshLoading(false);
    });
  };

  const columns = [
    {
      title: "Date",
      dataIndex: "createdAt",
      // render: (req) => req?.name,
      key: "Date",
      render: (_, request) => {
        return moment(request?.createdAt).utc().format("DD-MM-YYYY");
      },
    },
    {
      title: "Client",
      dataIndex: "client",
      render: (req) => req?.name,
      key: 'client',
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <AutoComplete
              style={{ margin: "1rem", width: "25rem" }}
              autoFocus
              value={selectedKeys[0] || clientSearchValue}
              options={clientOptions}
              onSearch={(value) => {
                const searchLower = value.toLowerCase();
                
                // Filter and sort clients by priority
                const filteredOptions = [...new Set(request
                  .filter(req => req.client?.name)
                  .map(req => req.client.name))]
                  .map(name => {
                    const nameLower = name.toLowerCase();
                    let priority = -1;
                    
                    // Highest priority: Starts with search term
                    if (nameLower.startsWith(searchLower)) {
                      priority = 2;
                    }
                    // Second priority: Word starts with search term
                    else if (nameLower.split(' ').some(word => word.toLowerCase().startsWith(searchLower))) {
                      priority = 1;
                    }
                    // Lowest priority: Contains search term
                    else if (nameLower.includes(searchLower)) {
                      priority = 0;
                    }
                    
                    return { name, priority };
                  })
                  .filter(item => item.priority >= 0)
                  .sort((a, b) => {
                    // Sort by priority first
                    if (b.priority !== a.priority) {
                      return b.priority - a.priority;
                    }
                    // Then alphabetically
                    return a.name.localeCompare(b.name);
                  })
                  .map(item => ({ value: item.name }));
  
                setClientOptions(filteredOptions);
                setClientSearchValue(value);
                setSelectedKeys(value ? [value] : []);
              }}
              onSelect={(value) => {
                setSelectedKeys([value]);
                confirm();
              }}
              onChange={(value) => {
                setSelectedKeys(value ? [value] : []);
              }}
              placeholder="Search Client"
            />
            <Button
              style={{ margin: "1rem" }}
              type="primary"
              onClick={() => confirm()}
            >
              Search
            </Button>
            <Button
              style={{ marginRight: "1rem" }}
              onClick={() => {
                clearFilters({ confirm: true });
                setClientSearchValue('');
                setClientOptions([]);
                setSelectedKeys([]);
                confirm();
              }}
            >
              Reset
            </Button>
          </>
        );
      },
      filterIcon: () => <SearchOutlined />,
      onFilter: (value, record) => {
        if (!value) return true;
        const clientName = record.client?.name || '';
        const searchValue = value.toLowerCase();
        const recordName = clientName.toLowerCase();
        
        // Prioritize exact matches and starts with
        if (recordName.startsWith(searchValue)) {
          return true;
        }
        
        // Then check for word starts
        if (recordName.split(' ').some(word => word.toLowerCase().startsWith(searchValue))) {
          return true;
        }
        
        // Finally check for contains
        return recordName.includes(searchValue);
      },
    },
    {
      title: "Product",
      width: "15%",
      render: (req) => {
        const productName = req?.product?.name || 'Product not assigned';
        const productBarcode = req?.product?.barcode ? `(${req.product.barcode})` : "";
        return `${productName} ${productBarcode}`;
      },
      key: "Product",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
        style={{ margin: "1rem", width: "25rem" }}
        autoFocus
        value={selectedKeys[0]}
        onChange={(e) => {
          setSelectedKeys(e.target.value ? [e.target.value] : []);
        }}
        onPressEnter={() => {
          fuzzyFilter(selectedKeys[0]);
        }}
        onBlur={() => {
          fuzzyFilter(selectedKeys[0]);
        }}
        placeholder="Search"
      ></Input>
      <Button
        style={{ margin: "1rem" }}
        type="primary"
        onClick={() => {
          fuzzyFilter(selectedKeys[0]);
        }}
      >
        Search
      </Button>
      <Button
        style={{ marginRight: "1rem" }}
        onClick={() => {
          clearFilters({ confirm: true });
          setFilteredData(false);
          setSelectedKeys("");
          confirm();
        }}
      >
        Reset
      </Button>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        const productName = record?.product?.name || '';
        return productName
          .replace(/[^a-zA-Z]/g, "")
          .toLowerCase()
          .includes(value.replace(/[^a-zA-Z]/g, "").toLowerCase());
      },
    },
   
    {
      title: "Task",
      width: "15%",
      dataIndex: "task",
      render: (req) => req?.task_number,
      key: "task",
    },
   

    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (_, request) => {
        return humanize(request.status)
      },
      filters: [
        { text: "Closed", value: "closed" },
        { text: "Rejected", value: "rejected" },
       
          ],

      onFilter: (value, record) => {

     
        return record?.status?.includes(value)
      }
      ,
    },

  ];

  return (
    <>
      <PageHeader
        className="site-page-header"
        style={{ padding: 0, marginTop: -15 }}
        title="Historical Stand-By Product Request"
        extra={[
          <Button
            icon={<RedoOutlined />}
            loading={refreshLoading}
            onClick={refresh}
            key="1"
            type="dashed"
          ></Button>,
        ]}
      />
      <Skeleton active loading={tableLoading}>
      <Table
        rowKey={"_id"}
        columns={columns}
        pagination={true}
        dataSource={filteredData ? filteredData : request}
      />
      </Skeleton>
      
    </>
  );
};

export default StandByProductReq;
